export default __webpack_public_path__ + "img/arrow_left.319f5abb.svg";